import React from 'react';

const ChatInput = ({ message, setMessage, handleSendMessage, connectionStatus }) => {
  return (
    <div className="chat__input-container">
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && !e.shiftKey && handleSendMessage()}
        placeholder={connectionStatus === 'connected' ? "Type your message" : "Connecting..."}
        className="chat-input"
        disabled={connectionStatus !== 'connected'}
        maxLength={1000}
      />
      <button 
        onClick={handleSendMessage} 
        className="chat__send-button"
        disabled={connectionStatus !== 'connected' || !message.trim()}
      >
        Enviar
      </button>
    </div>
  );
};

export default ChatInput;

